// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MtorApplications_AppScreenWrapper__MrQ1g {
  padding: 2px;
  border-radius: 24px;
  background: linear-gradient(
    180deg,
    rgba(46, 153, 234, 0) 21.85%,
    #2e99ea 99.83%
  );
}

.MtorApplications_TopRightCorner__67ewv {
  position: absolute;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background-color: #122955;
  top: -44px;
  right: -54px;
  z-index: 5;
}
`, "",{"version":3,"sources":["webpack://./src/components/Landing/MtorApplications/MtorApplications.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB;;;;GAIC;AACH;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,UAAU;AACZ","sourcesContent":[".AppScreenWrapper {\n  padding: 2px;\n  border-radius: 24px;\n  background: linear-gradient(\n    180deg,\n    rgba(46, 153, 234, 0) 21.85%,\n    #2e99ea 99.83%\n  );\n}\n\n.TopRightCorner {\n  position: absolute;\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  background-color: #122955;\n  top: -44px;\n  right: -54px;\n  z-index: 5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AppScreenWrapper": `MtorApplications_AppScreenWrapper__MrQ1g`,
	"TopRightCorner": `MtorApplications_TopRightCorner__67ewv`
};
export default ___CSS_LOADER_EXPORT___;
